import {
  Actions,
  NotificationType,
} from 'ha/modules/RealtimeMessaging/constants';

import { addMessage, readMessages, getUpdatedConversation } from '../actions';

import { getConversationId, getInitial } from '../reducer';

export default ({ dispatch, getState }) => next => action => {
  next(action);

  const state = getState();
  const isInitialState = getInitial(state);
  const conversationId = getConversationId(state);

  if (
    isInitialState === undefined ||
    action.type !== Actions.RECEIVE_MESSAGE ||
    conversationId !== action.payload.message.conversationId
  ) {
    return;
  }

  if (action.payload.type === NotificationType.conversationMessage) {
    if (action.payload.message.isSystem) {
      dispatch(getUpdatedConversation(action.payload.message.conversationId));
    }

    dispatch(addMessage(action.payload.message));
  }

  if (action.payload.type === NotificationType.conversationRead) {
    dispatch(readMessages(action.payload.message));
  }
};
